<template>
  <div>
    <v-btn
      class="button-hover"
      icon
      @click="$emit('remove')"
      :disabled="disabledView"
    >
      <v-avatar size="25">
        <img
          v-if="selectAll"
          :src="
            selectAll.address
              ? getCompanyImage(selectAll.id)
              : getImageUrl(selectAll.id)
          "
        />
        <img
          v-if="!selectAll"
          :src="
            tasks.user_assignee_id
              ? getImageUrl(tasks.user_assignee_id)
              : getCompanyImage(tasks.company_id)
          "
        />
        <v-icon :disabled="disabledView" size="20">delete</v-icon>
      </v-avatar>
    </v-btn>
  </div>
</template>

<script>
import { activitiesTasksDataMixin } from "../../../../../mixins/field/activitiesTasksDataMixin";
export default {
  name: "AssignmentTaskRemoveButton",

  mixins: [activitiesTasksDataMixin],

  props: {
    /**
     * receives the task to show user image
     */
    tasks: {
      type: Object
    },
    /**
     * when in view mode disabled is true
     */
    disabledView: {
      type: Boolean
    },
    /**
     * receives the selected user in the assign all button (upper left)
     */
    selectAll: {
      type: Object,
      default: null
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Molecules/AssignmentTaskRemoveButton.vue